import Reports from "./Reports"

type Props = { data: any; view: string }

function ReportsBoldContent({ data, view }: Props) {
  return <Reports hasBoldDescription={true} data={data} view={view} />
}

export default ReportsBoldContent
